export default {
  reportBuilder: 'Berichte',
  subheadline: 'Diese Einstellungen definieren das globale Erscheinungsbild von Qmulus generierten PDFs.',
  reportForm: {
    size: {
      label: 'Standardpapiergröße',
      tooltip: 'Definiert die Papiergröße welche immer vorausgewählt ist.',
    },
    language: {
      label: 'Sprache',
      tooltip: 'Die Sprachauswahl steuert wie Zeitstempel und andere lokalisierte Textfragmente im Report angezeigt werden.',
    },
    logo: {
      label: 'Logo',
      tooltip: 'Das gewählte Logo wird in der Kopfzeile eines jeden Reports angezeigt.',
    },
    header: {
      height: {
        tooltip: 'Definiert die Höhe der Kopfzeile, die auf jeder Reportseite verwendet wird.',
      },
      contentLeft: {
        tooltip: 'Definiert den linken Kopfzeilentext, der auf jeder Reportseite angezeigt wird.',
      },
      contentCenter: {
        tooltip: 'Definiert den zentrierten Kopfzeilentext, der auf jeder Reportseite angezeigt wird.',
      },
      contentRight: {
        tooltip: 'Definiert den rechten Kopfzeilentext, der auf jeder Reportseite angezeigt wird.',
      },
    },
    footer: {
      contentLeft: {
        tooltip: 'Definiert den linken Fußzeilentext, der auf jeder Reportseite angezeigt wird.',
      },
      contentCenter: {
        tooltip: 'Definiert den zentrierten Fußzeilentext, der auf jeder Reportseite angezeigt wird.',
      },
      contentRight: {
        tooltip: 'Definiert den rechten Fußzeilentext, der auf jeder Reportseite angezeigt wird.',
      },
    },
  },
  errors: {
    unsupportedFileType: 'Das aktuelle Logo ist ein nicht unterstützes Dateiformat. Bitte lade ein neues Logo hoch.',
    logoLoadingFailure: 'Das aktuelle Logo konnte nicht geladen werden. Wir empfehlen ein neues Logo hochzuladen.',
  },
};
